"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconVariablePrice = function IconVariablePrice(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M7 43h34v-2H9V5H7zm32.343-14H41v-2h-1.657a1.86 1.86 0 0 1-1.437-.672l-2.132-2.557a3.867 3.867 0 0 0-5.7-.259l-.855.856a1.867 1.867 0 0 1-3.02-.547l-.912-2.008a3.867 3.867 0 0 0-6.914-.251l-2.435 4.465A1.87 1.87 0 0 1 14.3 27H11v2h3.3a3.86 3.86 0 0 0 3.392-2.016l2.436-4.464a1.866 1.866 0 0 1 3.338.121l.912 2.007a3.865 3.865 0 0 0 6.254 1.134l.855-.856a1.86 1.86 0 0 1 1.406-.544 1.84 1.84 0 0 1 1.347.67l2.133 2.557A3.86 3.86 0 0 0 39.343 29",
    clipRule: "evenodd"
  })));
};

export { IconVariablePrice, IconVariablePrice as default };
